import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { classNames } from "../lib"
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"
import { useEffect, useRef } from "react"

const Tribute = () => {
  const ref = useRef<HTMLButtonElement>(null)
  const disclosureButton = "h-8 w-8 rounded-full bg-rose-500 drop-shadow-md"

  useEffect(() => {
    ref.current?.parentElement?.classList.remove("h-32")
  }, [])

  return (
    <Disclosure as="div" ref={ref} className="scroll-m-0">
      {({ open, close }) => (
        <>
          <DisclosureButton as="div" className={open ? "" : "cursor-pointer"} disabled={open}>
            <p
              className={classNames(
                "mx-auto max-w-prose px-8",
                open ? "" : "line-clamp-3 gradient-mask-b-10"
              )}
            >
              In 2021, Pastor Kikuo Kanemoto went to be with our Lord Savior Jesus Christ. This
              Chuukese translation was a life work for Pastor Kikuo—one that took great time and
              effort, in which he labored for the best possible way to convey God&rsquo;s word to
              the people in a familiar way. With this task also came the struggles, the setbacks,
              and the sacrifice he made to see that this work the Lord had given him would be
              completed. Through it all, and in the humble way he worked, we know without a doubt
              that this task brought Pastor Kikuo great joy.
            </p>
            {!open && (
              <div className="mt-[-29px] flex justify-center text-white">
                <ChevronDownIcon className={disclosureButton} />
              </div>
            )}
          </DisclosureButton>
          <DisclosurePanel as="div">
            <p className="mx-auto max-w-prose px-8">
              Pastor Kikuo often shared of the gratitude he had toward his wife and co-laborer
              Sandy—someone who also gave so much time and energy to see this work completed. What a
              blessing to the church it was to see them in marriage, laboring for the Gospel and for
              God&rsquo;s word to be known afresh for the people and country they loved.
            </p>
            <div className="relative pt-[50%]">
              <iframe
                src="https://player.vimeo.com/video/811498082?h=64fe4b2961&badge=0&autopause=0&player_id=0&app_id=58479&loop=0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderWidth: 0,
                }}
                title="Chuukese Bible: Why This Translation?"
              ></iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
            <p className="mx-auto max-w-prose px-8">
              We are grateful that before his passing, Pastor Kikuo saw this translation work go
              through its first printing and distribution, and also knew that this translation would
              be available on the internet for a far greater reach and accessibility to the next
              generation.
            </p>
            <p className="mx-auto max-w-prose px-8">
              It was always Pastor Kikuo&rsquo;s hope that this translation would stir up greater
              reverence and glory to God in every reading, sharing, teaching, preaching, and
              proclaiming of God&rsquo;s word. Pastor Kikuo would always say of the translation,
              &ldquo;To God be the glory.&rdquo; May this translation be one more means (among many)
              with which the Chuukese church can glorify God and enjoy him forever.
            </p>
            <DisclosureButton
              className="mx-auto flex text-white"
              onClick={evt => {
                evt.preventDefault()

                close()
                if (ref.current) {
                  // @see https://stackoverflow.com/questions/24665602/scrollintoview-scrolls-just-too-far
                  const yOffset = -180
                  const y = ref.current.getBoundingClientRect().top + window.scrollY + yOffset
                  window.scrollTo({ top: y, behavior: "smooth" })
                }
              }}
            >
              <ChevronUpIcon className={disclosureButton} />
            </DisclosureButton>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}

export default Tribute
